import { DownloadTypeFormView } from '../view/DownloadTypeFormView';
import { templateDownloadTypeForm } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../../../framework/BaseWebComponentController';
import { DownloadTypeFormWebComponent } from '..';
import { DownloadTypeViewData } from '../types';
import { KitDataSummary } from '../../../../../packages/downloadKitButtonSelector/constants';

export class DownloadTypeFormController extends BaseWebComponentController {
  public component: DownloadTypeFormWebComponent;
  public view: DownloadTypeFormView;
  public viewConstructor: typeof DownloadTypeFormView;

  constructor(component: DownloadTypeFormWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: DownloadTypeFormView,
      viewTemplate: templateDownloadTypeForm,
    });
  }

  async getDataForView(): Promise<DownloadTypeViewData> {
    const kitData: KitDataSummary[] = this.dependencies.getKitData();
    return {
      kitData: kitData,
    };
  }
}
